import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import ONBOARDING_TOOLTIP_CLASS_NAME from '../../theme/constants/tooltip';
import { preofferSimplifiedStatusToText, preofferCacheStatusToText, getNonComplianceReasons } from '../../helpers/preoffer-cache-status-to-text';
import { containerStyles, flexCenterStyles, containerFlexCenterStyles } from '../../constants/common-box-styles';

const FactoringStatusCell = ({ invoice }) => {
  const statusText = preofferSimplifiedStatusToText(invoice);
  const content = (
    <Typography variant="body2">
      {statusText}
    </Typography>
  );
  const tooltipText = preofferCacheStatusToText(invoice);
  const nonComplianceReasons = getNonComplianceReasons(invoice);

  if (statusText === 'No financiable' && nonComplianceReasons.length > 0) {
    return (
      <Box sx={containerStyles}>
        <Tooltip
          title={(
            <>
              <Typography
                variant="body2"
                textAlign="center"
                sx={{ maxWidth: 200 }}
              >
                {nonComplianceReasons.join(', ')}
              </Typography>
            </>
          )}
          placement="bottom"
          classes={{
            tooltip: ONBOARDING_TOOLTIP_CLASS_NAME,
          }}
          componentsProps={{
            tooltip: {
              sx: { marginTop: '-10px!important' },
            },
          }}
        >
          <Box sx={flexCenterStyles}>
            {content}
          </Box>
        </Tooltip>
      </Box>
    );
  }

  if (!invoice.preofferSelectable?.selectable && tooltipText) {
    return (
      <Box sx={containerStyles}>
        <Tooltip
          title={(
            <>
              <Typography
                variant="body2"
                textAlign="center"
                sx={{ maxWidth: 150 }}
              >
                {tooltipText}
              </Typography>
            </>
          )}
          placement="bottom"
          classes={{
            tooltip: ONBOARDING_TOOLTIP_CLASS_NAME,
          }}
          componentsProps={{
            tooltip: {
              sx: { marginTop: '-10px!important' },
            },
          }}
        >
          <Box sx={flexCenterStyles}>
            {content}
          </Box>
        </Tooltip>
      </Box>
    );
  }

  return (
    <Box sx={containerFlexCenterStyles}>
      {content}
    </Box>
  );
};

FactoringStatusCell.propTypes = {
  invoice: PropTypes.shape({
    preofferSelectable: PropTypes.shape({
      status: PropTypes.string,
      selectable: PropTypes.bool,
    }).isRequired,
  }).isRequired,
};

export default FactoringStatusCell;
